/* eslint-disable linebreak-style */
import React, {useRef, useState, useEffect} from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import Loader from 'react-loader-spinner';
import {
  Card,
} from '@material-ui/core';

import { 
  GridComponent, 
  ColumnsDirective, 
  ColumnDirective, 
  Selection,
  Page, 
  Inject,
  Toolbar, 
  Sort, 
  CommandColumn, 
  Resize, 
  ColumnMenu,
  Edit,
  ForeignKey,
  Filter
} from '@syncfusion/ej2-react-grids';
import { L10n, getValue, createElement} from '@syncfusion/ej2-base';
import { Browser } from '@syncfusion/ej2-base';
import { withSnackbar } from 'notistack';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './orderstable.css';
import { dataFormatRO } from '../../../../utils/functiiComune';
import { buildNewOrderTemplate } from '../../../../utils/orderWorkflow';
import {strapi} from '../../../../strapi/strapi.config';
import {fetchOrderDetailGraphql} from '../../../../strapi/graphql.orders';
import { setOrdersSuccess, setCurrentOrder, setCurrentItem, setUpdatedOrder, setDeletedItems, setOrdersStart} from '../../../../redux/order/order.actions';
import { selectOrderCurrentProduct, selectOrderOrders, selectOrderOrdersPagination }from '../../../../redux/order/order.selectors';
import { selectCurrentUser }from '../../../../redux/user/user.selectors';
import { selectOtherLoading}from '../../../../redux/other/other.selectors';
import { selectLookupFirmeComisionar } from '../../../../redux/lookup/lookup.selectors';
import {isFeatureEnabled} from '../../../../config/featureFlags';
import { t, orderStatusLabel } from '../../../../i18n';

L10n.load({
  'ro-RO': {
    'grid': {
      'Add': t('ordersTable.add'),
      'Edit': t('ordersTable.edit'),
      'Delete': t('ordersTable.delete'),
      'Update': t('ordersTable.update'),
      'Cancel': t('ordersTable.cancel'),
      'Save': t('ordersTable.save'),
      'Item': t('ordersTable.item'),
      'Items': t('ordersTable.items'),
      'EmptyRecord': t('ordersTable.emptyRecord'),
      'EditOperationAlert': t('ordersTable.editOperationAlert'),
      'DeleteOperationAlert': t('ordersTable.deleteOperationAlert'),
      'SaveButton': t('ordersTable.saveButton'),
      'CancelButton': t('ordersTable.cancelButton'),
      'ConfirmDelete': t('ordersTable.confirmDelete'),
      'CancelEdit': t('ordersTable.cancelEdit')
    },
    'pager':{
      'currentPageInfo': t('ordersTable.pagerCurrent'),
      'firstPageTooltip': t('ordersTable.pagerFirst'),
      'lastPageTooltip': t('ordersTable.pagerLast'),
      'nextPageTooltip': t('ordersTable.pagerNext'),
      'nextPagerTooltip': t('ordersTable.pagerNext'),
      'previousPageTooltip': t('ordersTable.pagerPrevious'),
      'previousPagerTooltip': t('ordersTable.pagerPrevious'),
      'totalItemsInfo': t('ordersTable.pagerTotal')
    }
  }
}); 

const useStyles = makeStyles(() => ({
  gridContainer: {
    height: '100%', // Ocupă întreaga înălțime a containerului părinte
    display: 'flex',
    flexDirection: 'column'
  },
  spinner:{
    textAlign: 'center',
    padding:'200px'
  },
  netransmisa:{
    color:'orange'
  }
}));

const GRID_OPERATOR_TO_STRAPI_SUFFIX = {
  contains: '_contains',
  startswith: '_starts_with',
  endswith: '_ends_with',
  equal: '',
  notequal: '_ne',
  greaterthan: '_gt',
  greaterthanorequal: '_gte',
  lessthan: '_lt',
  lessthanorequal: '_lte'
};

const normalizeFilterValue = (value)=>{
  if (value instanceof Date) {
    return value.toISOString();
  }
  return value;
};

const buildApiFiltersFromGridColumns = (columns = [])=>{
  if (!Array.isArray(columns)) {
    return {};
  }
  return columns.reduce((accumulator, filterColumn)=>{
    if (!filterColumn || !filterColumn.field) {
      return accumulator;
    }
    if (String(filterColumn.predicate || 'and').toLowerCase() === 'or') {
      // Keep behavior predictable for now: only AND filters are sent server-side.
      return accumulator;
    }
    const rawValue = normalizeFilterValue(filterColumn.value);
    if (rawValue === null || rawValue === undefined || rawValue === '') {
      return accumulator;
    }
    const operator = String(filterColumn.operator || 'equal').toLowerCase();
    const suffix = Object.prototype.hasOwnProperty.call(GRID_OPERATOR_TO_STRAPI_SUFFIX, operator)
      ? GRID_OPERATOR_TO_STRAPI_SUFFIX[operator]
      : '';
    const key = suffix ? `${filterColumn.field}${suffix}` : filterColumn.field;
    accumulator[key] = rawValue;
    return accumulator;
  }, {});
};

const buildApiSortFromGrid = (gridRef, fallbackSort = 'id:desc')=>{
  const sortColumns = gridRef?.current?.sortSettings?.columns;
  if (!Array.isArray(sortColumns) || sortColumns.length === 0) {
    return fallbackSort;
  }
  const primarySort = sortColumns[0];
  if (!primarySort?.field) {
    return fallbackSort;
  }
  const direction = String(primarySort.direction || 'Descending').toLowerCase().startsWith('asc')
    ? 'asc'
    : 'desc';
  return `${primarySort.field}:${direction}`;
};

const asStableJson = (value)=>{
  try {
    return JSON.stringify(value || {});
  } catch (error) {
    return '';
  }
};

const OrdersTable = props => {
  const { currentUser,currentProduct,history,setOrdersStart,setOrdersSuccess,setCurrentOrder, loading, setCurrentItem, setUpdatedOrder, orders, ordersPagination, firmeComisionar, setDeletedItems, enqueueSnackbar,} = props;
  const isServerPagingEnabled = isFeatureEnabled('ordersServerPaging');
  const isGraphqlReadEnabled = isFeatureEnabled('ordersGraphqlRead');
  const currentPage = Number(ordersPagination?.page || 1);
  const currentPageSize = Number(ordersPagination?.pageSize || 12);
  // State pentru loading local
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isInitialOrdersLoadPending, setIsInitialOrdersLoadPending] = useState(isServerPagingEnabled);
  const [isPageRequestInFlight, setIsPageRequestInFlight] = useState(false);
  const [, setServerFilters] = useState({});
  const [, setServerSort] = useState('id:desc');
  const serverFiltersRef = useRef({});
  const serverSortRef = useRef('id:desc');
  const pendingPageRef = useRef(1);
  const pendingPageSizeRef = useRef(12);
  const pageRetryRef = useRef(0);
  const totalServerRecords = Number(ordersPagination?.total || 0);
  const gridDataSource = isServerPagingEnabled
    ? { result: Array.isArray(orders) ? orders : [], count: totalServerRecords }
    : orders;
  const firmeComisionarIdsKey = (firmeComisionar || []).map(firma => firma.id).join(',');

  // Effect pentru a detecta schimbările în comenzi
  useEffect(() => {
    // Activăm loading-ul când se schimbă datele
    setIsTableLoading(true);
    
    // Dezactivăm loading-ul după un scurt delay pentru o tranziție fluidă
    const timer = setTimeout(() => {
      setIsTableLoading(false);
    }, 300);
    
    return () => clearTimeout(timer);
  }, [orders]);

  const loadOrdersPage = (pageToLoad = 1, pageSizeToLoad = 12, overrides = {})=>{
    if (!currentProduct?.cod || !currentUser?.idFirma?.id) {
      return;
    }
    const isComisionar = currentUser?.idFirma?.cfg1 === 'DA';
    const firmeAfiliateIds = (firmeComisionar || [])
      .map(firma => firma?.id)
      .filter(id => id !== null && id !== undefined && id !== '');
    const idFirmeComisionar = firmeAfiliateIds.length > 0
      ? firmeAfiliateIds
      : [currentUser?.idFirma?.id].filter(id => id !== null && id !== undefined && id !== '');
    const effectiveFilters = overrides.filters || serverFiltersRef.current || {};
    const effectiveSort = overrides.sort || serverSortRef.current || 'id:desc';
    if (isServerPagingEnabled) {
      pendingPageRef.current = Number(pageToLoad || 1);
      pendingPageSizeRef.current = Number(pageSizeToLoad || 12);
      if (!overrides.keepRetry) {
        pageRetryRef.current = 0;
      }
      setIsPageRequestInFlight(true);
      setIsInitialOrdersLoadPending(true);
    }
    const basePayload = {
      idFirma: currentUser.idFirma.id,
      tipProdus: currentProduct.cod,
      subTip: currentProduct.subTip,
      filters: effectiveFilters,
      page: pageToLoad,
      pageSize: pageSizeToLoad,
      sort: effectiveSort
    };
    if (isComisionar) {
      setOrdersStart({
        ...basePayload,
        idFirmeComisionar,
        isComisionar: true
      });
      return;
    }
    setOrdersStart(basePayload);
  };

  useEffect(()=>{
    serverFiltersRef.current = {};
    setServerFilters({});
    serverSortRef.current = 'id:desc';
    setServerSort('id:desc');

    if (!isServerPagingEnabled) {
      setIsInitialOrdersLoadPending(false);
      setIsPageRequestInFlight(false);
      loadOrdersPage(1, currentPageSize, {
        filters: {},
        sort: 'id:desc'
      });
      return;
    }
    loadOrdersPage(currentPage, currentPageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isServerPagingEnabled, currentProduct?.cod, currentProduct?.subTip, currentUser?.idFirma?.id, currentUser?.idFirma?.cfg1, firmeComisionarIdsKey]);

  useEffect(()=>{
    if (!isServerPagingEnabled || !isPageRequestInFlight) {
      return;
    }
    const serverPagingReady = ordersPagination?.serverPaging === true;
    const pageMatched = Number(ordersPagination?.page || 0) === Number(pendingPageRef.current || 0);
    const pageSizeMatched = Number(ordersPagination?.pageSize || 0) === Number(pendingPageSizeRef.current || 0);
    if (serverPagingReady && pageMatched && pageSizeMatched) {
      setIsPageRequestInFlight(false);
      setIsInitialOrdersLoadPending(false);
      pageRetryRef.current = 0;
      return;
    }

    if (serverPagingReady && (!pageMatched || !pageSizeMatched)) {
      if (pageRetryRef.current < 1) {
        pageRetryRef.current += 1;
        loadOrdersPage(pendingPageRef.current, pendingPageSizeRef.current, {
          filters: serverFiltersRef.current,
          sort: serverSortRef.current,
          keepRetry: true
        });
        return;
      }
      // Nu ținem gridul blocat la infinit dacă backend-ul răspunde pe altă pagină.
      setIsPageRequestInFlight(false);
      setIsInitialOrdersLoadPending(false);
      pageRetryRef.current = 0;
    }
  }, [
    isServerPagingEnabled,
    isPageRequestInFlight,
    ordersPagination?.serverPaging,
    ordersPagination?.page,
    ordersPagination?.pageSize,
    orders?.length
  ]);

  const dezactivareAdauga=()=>{
    if(currentProduct.cod==='jv' && currentProduct.subTip===''){
      return true;
    }else{
      return false;
    }
  }

  const toolbarOptions =[
    { text: t('ordersTable.add'), tooltipText: t('ordersTable.addTooltip'), prefixIcon: 'e-add', id: 'Adauga', disabled:dezactivareAdauga() },
    { text: t('ordersTable.edit'), tooltipText: t('ordersTable.editTooltip'), prefixIcon: 'e-edit', id: 'Modifica' },
    { text: t('ordersTable.delete'), tooltipText: t('ordersTable.deleteTooltip'), prefixIcon: 'e-delete', id: 'Sterge' },
  ];
  const editSettings = { allowDeleting: false, mode: 'Dialog', allowEditOnDblClick: false, showDeleteConfirmDialog: true };
  const sortingOptions = {columns: [{ field: 'id', direction: 'Descending' }]}
  const selectionsettings = {checkboxMode: 'ResetOnRowClick',type: 'Single' };
  const classes = useStyles();
  const masterGrid = useRef(null)
//----------------------------------------------------------------------------------------------------
  const filterOptions = {
    type: 'Menu',
    operators: {
      stringOperator: [
        { value: 'contains', text: t('ordersTable.filterContains') },
        { value: 'startswith', text: t('ordersTable.filterStartsWith') },
        { value: 'endswith', text: t('ordersTable.filterEndsWith') }
      ]
    },
    mode: 'Immediate'
  };

  //----------------------------------------------------------------------------------------------------
  
  //----------------------------------------------------------------------------------------------------
  const jsonCopy=(src)=>{
    return JSON.parse(JSON.stringify(src));
  }
  //----------------------------------------------------------------------------------------------------
  const ensureOrderShape = (orderRecord = {})=>({
    ...orderRecord,
    comandarepers: Array.isArray(orderRecord?.comandarepers) ? orderRecord.comandarepers : []
  });
  //----------------------------------------------------------------------------------------------------
  const fetchOrderDetailForState = async (orderRecord)=>{
    if (!orderRecord || !orderRecord.id) {
      return ensureOrderShape(orderRecord || {});
    }
    const shouldFetchDetail = isServerPagingEnabled || !Array.isArray(orderRecord?.comandarepers);
    if (!shouldFetchDetail) {
      return ensureOrderShape(orderRecord);
    }
    if (isGraphqlReadEnabled) {
      try {
        const graphqlOrder = await fetchOrderDetailGraphql(orderRecord.id);
        if (graphqlOrder) {
          return ensureOrderShape(graphqlOrder);
        }
      } catch (graphqlError) {
        console.warn('[ordersGraphqlRead][fallback] reason=graphql-detail-error', graphqlError);
      }
    }
    try {
      const restOrder = await strapi.getEntry('comandas', orderRecord.id);
      if (restOrder) {
        return ensureOrderShape(restOrder);
      }
    } catch (restError) {
      console.warn('[ordersGraphqlRead][fallback] reason=rest-detail-error', restError);
    }
    return ensureOrderShape(orderRecord);
  }
  //----------------------------------------------------------------------------------------------------
  const rowselect=async (args)=>{
    let selRecord = args.data;
    setCurrentOrder({});
    setUpdatedOrder({});
    const selectedOrder = await fetchOrderDetailForState(selRecord);
    const currentSelection = masterGrid.current?.selectionModule?.data;
    if (!currentSelection || Number(currentSelection.id || 0) !== Number(selRecord?.id || 0)) {
      return;
    }
    vizualizareComandaSetCurentOrder(selectedOrder)
    vizualizareComandaSetUpdatedOrder(selectedOrder)
  }
  //----------------------------------------------------------------------------------------------------
  const rowdeselect=()=>{
    setCurrentOrder({});
  }
  //----------------------------------------------------------------------------------------------------
  const actionBegin=(args)=> {
    if (isServerPagingEnabled && args.requestType === 'paging') {
      const nextPage = Number(args.currentPage || currentPage || 1);
      const nextPageSize = Number(args.pageSize || currentPageSize || 12);
      const currentKnownPage = Number(ordersPagination?.page || currentPage || 1);
      const currentKnownPageSize = Number(ordersPagination?.pageSize || currentPageSize || 12);
      const shouldRequestPage = nextPage !== currentKnownPage || nextPageSize !== currentKnownPageSize;
      if (shouldRequestPage) {
        args.cancel = true;
        loadOrdersPage(nextPage, nextPageSize);
        return;
      }
    }

    if (args.requestType === 'save') {
      if (masterGrid.pageSettings.currentPage !== 1 && masterGrid.editSettings.newRowPosition === 'Top') {
        args.index = (masterGrid.pageSettings.currentPage * masterGrid.pageSettings.pageSize) - masterGrid.pageSettings.pageSize;
      }
      else if (masterGrid.editSettings.newRowPosition === 'Bottom') {
        args.index = (masterGrid.pageSettings.currentPage * masterGrid.pageSettings.pageSize) - 1;
      }
    }
  }
  //----------------------------------------------------------------------------------------------------
  const actionComplete=(args)=>{
    if (isServerPagingEnabled && args.requestType === 'filtering') {
      if (args.isInteracted === false) {
        return;
      }
      const nextFilters = buildApiFiltersFromGridColumns(args.columns || masterGrid?.current?.filterSettings?.columns || []);
      const currentFilters = serverFiltersRef.current || {};
      if (asStableJson(nextFilters) === asStableJson(currentFilters)) {
        return;
      }
      serverFiltersRef.current = nextFilters;
      setServerFilters(nextFilters);
      loadOrdersPage(1, currentPageSize, {
        filters: nextFilters
      });
      return;
    }

    if (isServerPagingEnabled && args.requestType === 'sorting') {
      if (args.isInteracted === false) {
        return;
      }
      const nextSort = buildApiSortFromGrid(masterGrid, 'id:desc');
      if (String(nextSort) === String(serverSortRef.current || 'id:desc')) {
        return;
      }
      serverSortRef.current = nextSort;
      setServerSort(nextSort);
      loadOrdersPage(1, currentPageSize, {
        sort: nextSort
      });
      return;
    }

    if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
      if (Browser.isDevice) {
        args.dialog.height = window.innerHeight - 90 + 'px';
        args.dialog.dataBind();    
      }
    }
  }
  //----------------------------------------------------------------------------------------------------

  const currencyFormatter=(field, data)=>{
    if (currentProduct.cod==='jv' || currentProduct.cod==='ro'|| currentProduct.cod==='jo'){
      return  getValue(field, data) + ' Lei';
    }else{
      return  getValue(field, data) + ' Euro';
    }

  }
  //----------------------------------------------------------------------------------------------------
  const dateFormatter=(field, data)=>{
    return  dataFormatRO(getValue(field, data)).substring(0, 10);
  }
  //----------------------------------------------------------------------------------------------------
  const customizeCell=(args)=>{
    if((args.column).field === 'stadiu' && args.data && args.cell) {
      if (getValue('stadiu', args.data) ==='NETRANSMISA'){
        args.cell.classList.add('netransmisa');
      } 
    }
  }
  //----------------------------------------------------------------------------------------------------
  const headerCellInfo=(args)=>{ 
    args.node.getElementsByClassName('e-checkbox-wrapper')[0] && args.node.getElementsByClassName('e-checkbox-wrapper')[0].remove(); 
  } 
  //----------------------------------------------------------------------------------------------------
  const clickHandlerMaster=async e=>{
    const { setCurrentOrder,setUpdatedOrder}=props;
    const selectedOrderRecord = masterGrid.current?.selectionModule?.data || null;
    //.....................................
    if (e.item.properties.id==='Adauga'){
      const template = buildNewOrderTemplate(currentProduct, currentUser);
      if (!template) {
        alert(t('ordersTable.missingProduct'));
        return;
      }
      const orderForState = {
        ...template,
        comandarepers: [...(template.comandarepers || [])]
      };
      setCurrentOrder(orderForState);
      setUpdatedOrder({
        ...orderForState,
        comandarepers: [...(orderForState.comandarepers || [])]
      });
      
      setDeletedItems([])
      let path = '/order';
      history.push(path);
    }
    //.....................................
    if (e.item.properties.id==='Modifica'){
      if (masterGrid.current.getSelectedRowIndexes().length){
        document.body.style.cursor = 'wait';
        let orderForEdit = null;
        try {
          orderForEdit = await fetchOrderDetailForState(selectedOrderRecord);
        } finally {
          document.body.style.cursor = 'pointer';
        }
        if (!orderForEdit) {
          enqueueSnackbar(t('ordersTable.loadOrderDetailError'),{
            variant: 'error',
            autoHideDuration:2500
          });
          return;
        }
        await vizualizareComandaSetCurentOrder(orderForEdit)
        await vizualizareComandaSetUpdatedOrder(orderForEdit)
        setDeletedItems([])
        setCurrentItem({}) 
        history.push('/order')
      }else{
        enqueueSnackbar(t('ordersTable.noOrderSelected'),{ 
          variant: 'error',
          autoHideDuration:1500
        })
      } 
    }
    //.....................................
    if (e.item.properties.id==='Sterge'){
      if(masterGrid.current.selectionModule.data.stadiu ==='NETRANSMISA'){
        confirmAlert({
          title: t('ordersTable.confirmDeleteTitle'),
          message: t('ordersTable.confirmDeleteMessage'),
          buttons: [
            {
              label: t('common.yes'),
              onClick: async () => {
                document.body.style.cursor = 'wait';
                await strapi.deleteEntry('comandas',masterGrid.current.selectionModule.data.id)
                  .catch(e=>(
                    props.enqueueSnackbar(t('ordersTable.deleteError', { error: e }),{ 
                      variant: 'error',
                      persist:true,  
                    })
                  ))
                  .then(()=>{
                    if (isServerPagingEnabled) {
                      loadOrdersPage(currentPage, currentPageSize)
                    } else {
                      setOrdersSuccess(orders.filter(order=>(order.id!==masterGrid.current.selectionModule.data.id)))
                    }
                    enqueueSnackbar(t('ordersTable.deleteSuccess'),{ 
                      variant: 'success',
                      autoHideDuration:1500
                    })
                    document.body.style.cursor = 'pointer';
                    masterGrid.current.refresh();
                  })
              }
            },
            {
              label: t('common.no'),
              onClick: () => {
                enqueueSnackbar(t('ordersTable.deleteCanceled'),{ 
                  variant: 'warning',
                  autoHideDuration:1500
                })    
              }
            }
          ]
        });
      }else{
        enqueueSnackbar(t('ordersTable.deleteOnlyDraftWarning'),{ 
          variant: 'warning',
        })
      }
    }   
  }
  //----------------------------------------------------------------------------------------------------
  const vizualizareComandaSetCurentOrder=(selectedRow)=>{
    return new Promise( (resolve) => { 
      setTimeout(async() => {
        setCurrentOrder(jsonCopy(selectedRow))
        resolve('ok')
      },50)
    })
  }
  //----------------------------------------------------------------------------------------------------
  const vizualizareComandaSetUpdatedOrder=(selectedRow)=>{
    return new Promise( (resolve) => { 
      setTimeout(async() => {
        setUpdatedOrder(jsonCopy(selectedRow))
        resolve('ok')
      },50)
    })
  }
  //----------------------------------------------------------------------------------------------------
  const vanzatorVizibilitate=()=>{
    if(currentUser.role.name==='Vanzator'){
      return false;
    }else{
      return true;
    }
  }
   
  if (loading===false) {
    return (
      <Card className="control-panel">
        <div className="control-section grid-container">
          {isServerPagingEnabled && isInitialOrdersLoadPending ? (
            <div className={classes.spinner}>
              <Loader
                color="#00BFFF"
                height={60}
                type="Puff"
                width={60}
              />
            </div>
          ) : (
            <>
          {isTableLoading && (
            <div className="grid-overlay">
              <Loader
                color="#00BFFF"
                height={50}
                type="Puff"
                width={50}
              />
            </div>
          )}
          <GridComponent 
            height='300px'
            actionBegin={actionBegin.bind(this)} 
            actionComplete={actionComplete.bind(this)}  
            allowFiltering={true}
            filterSettings={filterOptions}
            enablePersistence={false}
            allowPaging 
            allowResizing 
            allowSorting 
            allowTextWrap 
            dataSource={gridDataSource} 
            editSettings={editSettings}
            enableHover={false} 
            gridLines="Both"
            headerCellInfo={headerCellInfo}
            locale="ro-RO"
            pageSettings={isServerPagingEnabled
              ? { pageCount: 20, currentPage, pageSize: currentPageSize, totalRecordsCount: totalServerRecords }
              : { pageCount: 20 }
            }
            queryCellInfo={customizeCell}
            ref={masterGrid}
            rowDeselected={rowdeselect.bind(this)}
            rowSelected={rowselect.bind(this)} 
            selectedRowIndex={-1}
            selectionSettings={selectionsettings}
            sortSettings={sortingOptions}
            textWrapSettings={{wrapMode: 'Both'}}
            toolbar={toolbarOptions}
            toolbarClick={clickHandlerMaster}
          >
            <ColumnsDirective>
              <ColumnDirective
                allowEditing={false}
                headerText={t('ordersTable.colSelect')}
                textAlign="Center"
                type="checkbox"
                width="30"
              />
              <ColumnDirective
                field="id"
                headerText={t('ordersTable.colOrderNo')}
                isPrimaryKey
                textAlign="Center"
                width="110"
              />
              <ColumnDirective
                field="dataComanda"
                headerText={t('ordersTable.colDate')}
                textAlign="Center"
                valueAccessor={dateFormatter}
                width="110"
              />
              <ColumnDirective
                field="clientClient"
                headerText={t('ordersTable.colClient')}
                width="150"
              />
              <ColumnDirective
                field="valoareComanda"
                headerText={t('ordersTable.colOrderValue')}
                textAlign="Right"
                valueAccessor={currencyFormatter}
                visible={vanzatorVizibilitate()}
                width="120"
              />
              <ColumnDirective
                field="valoareClientFinal"
                headerText={t('ordersTable.colFinalValue')}
                textAlign="Right"
                valueAccessor={currencyFormatter}
                width="120"
              />
              <ColumnDirective
                field="stadiu"
                headerText={t('ordersTable.colStatus')}
                textAlign="Center"
                valueAccessor={(field, data)=> orderStatusLabel(getValue(field, data))}
                width="150"
              />
            </ColumnsDirective>
            
            <Inject services={[Selection, Page, Sort,Toolbar, CommandColumn, Resize, ColumnMenu, Edit, ForeignKey, Filter]}/>
          </GridComponent>
            </>
          )}
        </div>
      </Card>
    )
  } else {
    return (
      <div className={classes.spinner}>
        <Loader
          color="#00BFFF"
          height={100}
          type="Puff"
          width={100}
        />
      </div>
    );
  }
}

OrdersTable.propTypes = {
  className: PropTypes.string,
  currentProduct:PropTypes.object,
  currentUser:PropTypes.object,
  loading:PropTypes.bool,
  orders:PropTypes.array,
  ordersPagination:PropTypes.object,
  firmeComisionar:PropTypes.array
};

const mapStateToProps=state=>({
  currentProduct:selectOrderCurrentProduct(state),
  orders:selectOrderOrders(state),
  ordersPagination:selectOrderOrdersPagination(state),
  firmeComisionar:selectLookupFirmeComisionar(state),
  currentUser:selectCurrentUser(state),
  loading:selectOtherLoading(state),
})

const mapDispatchToProps=dispatch=>({
  setOrdersSuccess:(orders)=>dispatch(setOrdersSuccess(orders)),
  setCurrentOrder:order=>dispatch(setCurrentOrder(order)),
  setCurrentItem:item=>dispatch(setCurrentItem(item)),
  setUpdatedOrder:order=>dispatch(setUpdatedOrder(order)),
  setDeletedItems:items=>dispatch(setDeletedItems(items)),
  setOrdersStart:(idFirmaAndTipProdusAndTipProdus)=>dispatch(setOrdersStart(idFirmaAndTipProdusAndTipProdus)),
})

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(withSnackbar(OrdersTable)));
